$.fn.videoDisclaimerPlugin = function (options) {
    var pluginName = 'videoDisclaimerPlugin';

    var settings = $.extend({}, options);

    return this.each(function () {
        var lang = document.documentElement.getAttribute('lang');
        var videoFrames = document.querySelectorAll('.video-container-outer .js-yt-video');

        if (!videoFrames || videoFrames.length === 0) return;

        var DisclaimerUtils = {
            videosAreEnabled: function () {
                return localStorage.getItem('oebb-yt-videos') ? true : false;
            },

            toggleVideosLocalStorage: function () {
                if (this.videosAreEnabled()) {
                    localStorage.removeItem('oebb-yt-videos');
                } else {
                    localStorage.setItem('oebb-yt-videos', 'true');
                }
            },

            getNextHeadingLevel: function (tag) {
                var levels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
                if (!tag) return 'h1';

                var idx = levels.indexOf(tag.toLowerCase());
                if (idx === -1) return 'h1';
                if (idx >= levels.length - 1) return 'h6';

                return levels[idx + 1];
            },

            getLastHeadingBeforeElement: function (element, containerSelector) {
                containerSelector = containerSelector || 'main';
                var $container = $(containerSelector);
                if ($container.length === 0) return 'h1';

                var $allHeadings = $container.find('h1,h2,h3,h4,h5,h6').not('.video__disclaimer, .js-video');
                var lastHeading = null;

                $allHeadings.each(function () {
                    if (this.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) {
                        lastHeading = this;
                    }
                });

                return lastHeading ? lastHeading.tagName.toLowerCase() : 'null';
            },

            createDisclaimerElement: function ($videoWrapper, lang, getTextFunc) {
                var $video = $videoWrapper.find('.js-yt-video');
                var lastHeading = this.getLastHeadingBeforeElement($video[0], 'main');
                var nextHeadingTag = this.getNextHeadingLevel(lastHeading);

                var $disclaimer = $('<div>').addClass('video__disclaimer');
                var $headline = $('<' + nextHeadingTag + '>').text(getTextFunc('disclaimerHeadline'));
                var $paragraph = $('<p>').html(getTextFunc('disclaimerText'));

                $disclaimer.append($headline).append($paragraph);
                $videoWrapper.append($disclaimer);

                return $disclaimer;
            },

            createDisclaimerBtn: function ($videoWrapper, lang, getTextFunc, clickHandler) {
                var $btn = $('<button>').addClass('js-disclaimer-btn md-button video-disclaimer-btn').attr('aria-label', getTextFunc('disclaimerBtnAriaLabel'));

                $btn.on('click', clickHandler);

                $videoWrapper.append($btn);
                return $btn;
            },
        };

        prepareDisclaimerWrapper();
        prepareDisclaimerBtn();
        main(null);

        function main(event) {
            videoFrames.forEach(function (videoFrame) {
                var $videoWrapper = $(videoFrame.closest('.video-container-outer'));
                if (DisclaimerUtils.videosAreEnabled()) {
                    activateVideo(videoFrame, $videoWrapper);
                } else {
                    deactivateVideo(videoFrame, $videoWrapper);
                }
            });

            if (event) {
                const videoIFrame = $(event.target).closest('.video-container-outer').find('.js-yt-video')[0];
                videoIFrame.scrollIntoView();
                videoIFrame.focus();
            }
        }

        function activateVideo(videoFrame, $videoWrapper) {
            $videoWrapper.addClass('video--activated');
            videoFrame.classList.remove('video-deactivated');
            videoFrame.style.pointerEvents = 'unset';

            if (!videoFrame.classList.contains('js-lazy-frame')) {
                videoFrame.src = videoFrame.getAttribute('data-framesrc');
            }

            $videoWrapper.addClass('video--ready');
            setDisclaimerTxt($videoWrapper, true);
        }

        function deactivateVideo(videoFrame, $videoWrapper) {
            $videoWrapper.removeClass('video--activated');
            videoFrame.classList.add('video-deactivated');
            videoFrame.style.pointerEvents = 'none';
            videoFrame.src = '';
            $videoWrapper.addClass('video--ready');
            setDisclaimerTxt($videoWrapper, false);
        }

        function prepareDisclaimerWrapper() {
            videoFrames.forEach(function (videoFrame) {
                var $videoWrapper = $(videoFrame.closest('.video-container-outer'));

                if ($videoWrapper.find('.video__disclaimer').length === 0) {
                    DisclaimerUtils.createDisclaimerElement($videoWrapper, lang, getPropertyText);
                }
            });
        }

        function prepareDisclaimerBtn() {
            videoFrames.forEach(function (videoFrame) {
                var $videoWrapper = $(videoFrame.closest('.video-container-outer'));

                if ($videoWrapper.find('.js-disclaimer-btn').length === 0) {
                    DisclaimerUtils.createDisclaimerBtn($videoWrapper, lang, getPropertyText, function (event) {
                        DisclaimerUtils.toggleVideosLocalStorage();
                        main(event);
                        $('.waterfall-template:not(.edit-mode)').waterfallVideosDisclaimerPlugin();
                    });
                }
            });
        }

        function setDisclaimerTxt($videoWrapper, isEnabled) {
            var $disclaimerBtn = $videoWrapper.find('.js-disclaimer-btn');

            if (isEnabled) {
                $disclaimerBtn.text(getPropertyText('rejectButton'));
                $disclaimerBtn.attr('aria-pressed', true);
            } else {
                $disclaimerBtn.html('<span class="ic-play1"></span> ' + getPropertyText('acceptButton'));
                $disclaimerBtn.attr('aria-pressed', false);
            }
        }

        function getPropertyText(property) {
            var texts = $.fn.i18nPlugin();
            return texts[property] ? texts[property][lang] || texts[property]['en'] : '';
        }
    });
};
